/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workflowsUpdate } from "../../funcs/workflowsUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PutApiLeadScraperMicroserviceApiV1WorkspacesWorkflowRequestBody$inboundSchema,
};

export const tool$workflowsUpdate: ToolDefinition<typeof args> = {
  name: "workflows_update",
  description: `Update workflow details

Updates the details of a specific workflow`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workflowsUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
